(ns common.roles
  (:require
   [common.schema.entities.role :as role-schema]))

(def roles
  (->> role-schema/roles
       (keys)
       (set)))

;; [owner | ssg \ bsg \ user \ team-x \ admin \ zadmin \ sys-admin \ system]
;; 000000001 000000010 000000100

(def role-hierarchy
  (->
   (make-hierarchy)
    ;; backend system role - cannot be authenticated as and can create anything
   (derive :role/system :role/sys-admin)
    ;; Zapflow ADMIN role - limited to 2 people - can access customer data
   (derive :role/sys-admin :role/zadmin)
    ;; Zapflow employee - has privileges to invite new tenants and configure plans/features and view usage metadata - no access to tenant / customer business data
   (derive :role/zadmin :role/account-owner)
    ;; account owner - specific role for account owner - HACK should be cleand up
    ;; this is used only in back end serialization to allow and limit access to specific fields
    ;; to only the account holder and not even to admins
    ;; for instance validation tokens or jobs that should not be shown even to admins
   (derive :role/account-owner :role/admin)
    ;; tenant i.e. our customers admin
   (derive :role/admin :role/user)
    ;; tenant user
   (derive :role/user :role/guest-buy-side)
    ;; tenant's bsg
   (derive :role/guest-buy-side :role/guest-sell-side)
    ;; tenant's ssg
   (derive :role/guest-sell-side :role/guest-lp-portal)
    ;; tenant lp-portal guest
   (derive :role/guest-lp-portal :role/guest-survey)
    ;; tenant survey guest
   (derive :role/guest-survey :role/guest-counterparty-diligence)
    ;; tenant counterparty diligence guest
   (derive :role/guest-counterparty-diligence :role/authenticated)
    ;; user/password/MFA/SSO authenticated, but has not chosen a role/tenant for this session yet
   (derive :role/authenticated :role/none)))

;;
;; True if it is a guest role
;;

(def is-bsg-role? #{:role/guest-buy-side})

(def is-ssg-role? #{:role/guest-sell-side})

(def is-guest-role? #{:role/guest-sell-side :role/guest-buy-side :role/guest-lp-portal :role/guest-survey :role/guest-counterparty-diligence})

(def lp-portal-guest? #{:role/guest-lp-portal})

(defn admin?
  [role]
  (isa? role-hierarchy
        (or (:role/role role)
            role)
        :role/admin))
(defn zadmin?
  [role]
  (isa? role-hierarchy
        (or (:role/role role)
            role)
        :role/zadmin))
(defn user?
  [role]
  (isa? role-hierarchy
        (or (:role/role role)
            role)
        :role/user))

(defn lp-guest?
  [role]
  (or (= :role/guest-lp-portal role)
      (isa? role-hierarchy
            (or (:role/role role)
                role)
            :role/user)))

(defn sys-admin?
  [role]
  (isa? role-hierarchy
        (or (:role/role role)
            role)
        :role/sys-admin))

(defn has-access?
  [current-role required-role]
  (isa? role-hierarchy current-role required-role))

(defn user-or-admin?
  [role]
  (or (= role :role/user)
      (= role :role/admin)))

(defn compare-roles
  [role-a role-b]
  (cond (= role-a role-b) 0
        (isa? role-hierarchy role-a role-b) -1
        (isa? role-hierarchy role-b role-a) 1
        :else 0))



(defn resolve-role-field-access
  [role default-auth]
  (cond (has-access? role (:access/create default-auth))
        :x
        (has-access? role (:access/write default-auth))
        :w
        (has-access? role (:access/read default-auth))
        :r
        :else
        :none))

(defn read-access?
  [access]
  (contains? #{:x :w :r} access))

#_(defn resolve-role-field-access
    [role default-auth &
     [{:keys [no-access-value]
       :or   {no-access-value :none}}]]
    (cond (has-access? role (:access/create default-auth))
          :x
          (has-access? role (:access/write default-auth))
          :w
          (has-access? role (:access/read default-auth))
          :r
          :else
          no-access-value))
